import type { CSSProperties } from 'react';

/**
 * Parses a raw CSS declaration string (the exact `style="..."` value from the
 * design-locked HTML) into a React style object. Lets the ported pages keep
 * their inline styles verbatim — camelCasing the properties — so the design
 * stays pixel-identical without hand-transcribing every value.
 *
 * Values are kept as strings (React accepts string values for every property).
 * Splitting on ';' / first ':' is safe here because no value contains those
 * characters (commas inside rgba()/box-shadow are fine).
 */
export function css(style: string): CSSProperties {
  const out: Record<string, string> = {};
  for (const decl of style.split(';')) {
    const trimmed = decl.trim();
    if (!trimmed) continue;
    const idx = trimmed.indexOf(':');
    if (idx === -1) continue;
    const prop = trimmed.slice(0, idx).trim();
    const value = trimmed.slice(idx + 1).trim();
    // -webkit-font-smoothing → WebkitFontSmoothing; font-size → fontSize
    const key = prop.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase());
    out[key] = value;
  }
  return out as CSSProperties;
}
